module.exports = __webpack_public_path__ + "img/intercomdescribe4.543784b9.png";